import { render, staticRenderFns } from "./GroupRulesModal.vue?vue&type=template&id=2fb934cb"
import script from "./GroupRulesModal.vue?vue&type=script&lang=js"
export * from "./GroupRulesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports